<template>
    <div class='d-flex flex-row align-items-stretch'>
        <input :key='"d"+resetCounter' ref='date' style='width: 11em !important' class='form-control w-auto mr-1' type='date' :value='date' v-on:input='update()' v-on:change='update()'>
        <input :key='"t"+resetCounter' ref='time' style='width: 7em  !important' class='form-control w-auto mr-1' type='time' :value='time' v-on:input='update()' v-on:change='update()'>
        <!-- v-on:keyup='update()'  -->
        <div class='align-self-center'>
        <button 
            class='btn btn-light btn-sm btn-clear' 
            v-on:click.prevent="clear">x</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            
        },
    },
    data() {
        return {
            mutableValue: this.value,
            resetCounter: 0,
        };
    },
    computed: {
        date: {
            get() {
                //console.warn("GET!!!!!!");
                if(this.mutableValue && this.mutableValue.match(/^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/)) {
                    var parts = this.mutableValue.split(/[ T]/);
                    return parts[0];
                }
                return "";
            },
        },
        time: {
            get() {
                if(this.mutableValue && this.mutableValue.match(/[ T][0-9]{2}:[0-9]{2}/)) {
                    var match = this.mutableValue.split(/[ T]/)[1].match(/[0-9]{2}:[0-9]{2}/);
                    return match[0];

                    // In some future where we've switched to UTC on the server, use this to display
                    // times in the correct locale:
                    // return (new Date(this.mutableValue)).toLocaleTimeString();
                }
                return "";
            },
        }
    },
    watch: {
        value: {
            handler(after) {
                this.mutableValue = this.value;
                //this.resetCounter++;
            }
        }
    },
    methods: {
        update() {
            // console.log("Date has changed to: " + this.$refs.date.value + " " + this.$refs.time.value);
            // console.log(this.$refs.date);
            this.$emit('input', this.$refs.date.value + " " + this.$refs.time.value);    
        },
        clear() {
            this.mutableValue = null;
            this.$emit('input', null);
            this.reset();
        },
        reset() {
            // So annoying. If you enter a partial date, then the code has no way to know that that
            // is being displayed in the UI. So we force new components to refresh.
            this.resetCounter++;
        }
        
    },
};
</script>

<style scoped>
    .btn-clear {
        width: 22px; 
        height: 22px; 
        font-size: 13px; 
        padding: 0px;
        border: 1px solid #a0a0a0;
        border-radius: 0.25rem;
        font-weight: bold;
        color: rgb(120, 130, 140);
    }
</style>